import { Controller } from "@hotwired/stimulus"

// Auto-submits the surrounding form once the OTP input holds the full
// code. Fires on every `input` event, which includes iOS/macOS SMS
// AutoFill (autofill dispatches a synthetic `input`), so autofilled codes
// submit hands-free too.
export default class extends Controller {
  static values = { length: { type: Number, default: 6 } }

  connect() {
    this.submitted = false
  }

  check() {
    const digits = this.element.value.replace(/\D/g, "")

    if (digits.length < this.lengthValue) {
      this.submitted = false
      return
    }

    if (this.submitted) return
    this.submitted = true
    // snap the caret/scroll back to the start so the digits stay aligned
    // over their underlines once focus leaves the field
    this.element.setSelectionRange(0, 0)
    this.element.scrollLeft = 0
    this.element.blur()
    this.element.form?.requestSubmit()
  }
}
